import React from 'react';
import Button from '../Button';
import PoweredByStripe from '../PoweredByStripe/PoweredByStripe';
import PoweredByCheckoutPage from '../PoweredByCheckoutPage';
import resolveBadge, { BADGE } from '../../lib/resolveBadge';
import useCheckoutState from '../../hooks/useCheckoutState';
import resolveAffiliateBadgeToken from '../../lib/resolveAffiliateBadgeToken';
import { PAGE_TYPES } from '../../enums/page-types';

// Maps a checkout page type to the PoweredByCheckoutPage pageType (CTA copy + UTM).
const PAGE_TYPE_TO_BADGE = {
  [PAGE_TYPES.CHECKOUT]: 'checkout',
  [PAGE_TYPES.EVENT]: 'event',
  [PAGE_TYPES.FORM]: 'form',
};

/**
 * Renders the single badge at the foot of a checkout surface: either our "Powered
 * by Checkout Page" pill or the "Powered by Stripe" trust badge — never both. Which
 * one (or none) is decided by resolveBadge, applying the plan-based override and
 * mutual-exclusivity rules. The Stripe badge only applies to payment surfaces
 * (checkout/event), never forms. The confirmation view renders its own branding.
 */
export default function CheckoutBrandingBadge() {
  const { seller, theme, checkout, isConfirmation } = useCheckoutState();

  if (isConfirmation) return null;

  const badge = resolveBadge(seller, theme);

  if (badge === BADGE.CHECKOUT_PAGE) {
    return (
      <PoweredByCheckoutPage
        variant="pill"
        surface="checkout"
        pageType={PAGE_TYPE_TO_BADGE[checkout.type] || 'checkout'}
        affiliateToken={resolveAffiliateBadgeToken(seller)}
      />
    );
  }

  if (badge === BADGE.STRIPE) {
    const isPaymentSurface =
      checkout.type === PAGE_TYPES.CHECKOUT || checkout.type === PAGE_TYPES.EVENT;
    if (!isPaymentSurface) return null;

    return (
      <div className="cp_powered-by-stripe-wrapper py-2 w-full flex justify-center">
        <Button
          to="https://stripe.com"
          target="_blank"
          appearance="bare"
          className="cp_powered-by-stripe-link"
        >
          <PoweredByStripe style={theme.elements?.poweredByStripe?.styles?.badgeStyle} />
        </Button>
      </div>
    );
  }

  return null;
}
